import { CloserToolbarSelect } from '@/components/CloserLeads/CloserToolbarSelect'
import { GestorTabFiltersBar } from '@/components/Gestores/GestorTabFiltersBar'
import type { EntradaStatus } from '@/components/Gestores/gestorClienteEntradaConfig'

type Props = {
  search: string
  onSearchChange: (v: string) => void
  statusFilter: EntradaStatus
  onStatusChange: (v: EntradaStatus) => void
}

export function GestorEntradasFilters({
  search,
  onSearchChange,
  statusFilter,
  onStatusChange,
}: Props) {
  const hasActiveFilter = search.trim().length > 0 || statusFilter !== 'EM_ANDAMENTO'

  return (
    <GestorTabFiltersBar
      search={search}
      onSearchChange={onSearchChange}
      searchPlaceholder='Buscar entrada por cliente ou serviço…'
      searchAriaLabel='Buscar entradas'
      showClear={hasActiveFilter}
      onClearAll={() => {
        onSearchChange('')
        onStatusChange('EM_ANDAMENTO')
      }}
    >
      <CloserToolbarSelect
        value={statusFilter}
        onChange={(v) => onStatusChange(v as EntradaStatus)}
        options={[
          { value: 'EM_ANDAMENTO', label: 'Em andamento' },
          { value: 'CONCLUIDO', label: 'Concluídas' },
        ]}
        aria-label='Situação das entradas'
      />
    </GestorTabFiltersBar>
  )
}
